import { render, staticRenderFns } from "./1099.vue?vue&type=template&id=153c4d88&"
import script from "./1099.vue?vue&type=script&lang=ts&"
export * from "./1099.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports